import { h } from 'preact'
import Icon from '../../assets'
import IdeationStatus from '../../topic-list-view/IdeationStatus'

const TitleCell = () => {
  return (props: any) => {
    const { title, urls, ideaStatus, contentType, hasPinnedReply, hasBestAnswer, sticky } = props

    const { control, destination } = urls

    return (
      <div className='overview__table-title'>
        <div>
          <a href={window.location.origin + control} class='qa-title-link'>{title}</a>
          { ideaStatus && ideaStatus.name && (
            <span>
              <IdeationStatus topic={{ ideaStatus: ideaStatus }} />
            </span>
          )
          }
          { contentType === 'question' && !hasBestAnswer && <Icon icon='question' width={16} height={16} customClass='question-icon' /> }
          { contentType === 'question' && hasBestAnswer && <Icon icon='answer' width={16} height={16} customClass='question-answered-icon' /> }
          { hasPinnedReply && <Icon icon='pin' width={16} height={16} customClass='pin-icon' /> }
          { sticky && <Icon icon='stickyFlag' width={12} height={12} customClass='sticky-icon' /> }
        </div>
        {destination &&
          <a className='overview__destination-icon qa-destination-link' href={destination} target='_blank'>
            <Icon icon='externalLink' width={16} height={16} />
          </a>
        }
      </div>
    )
  }
}

export default TitleCell
